import {
	type Context,
	type FunctionComponent,
	type LazyExoticComponent,
	createContext,
	useContext,
} from 'react';

export type ScreenSpaceFlagsInjectedMessageTemplates = Record<
	string,
	| FunctionComponent<Record<string, unknown>>
	| LazyExoticComponent<FunctionComponent<Record<string, unknown>>>
>;

export const InjectedMessageTemplatesContext: Context<
	ScreenSpaceFlagsInjectedMessageTemplates | undefined
> = createContext<ScreenSpaceFlagsInjectedMessageTemplates | undefined>(undefined);

export const useInjectedMessageTemplates = ():
	| ScreenSpaceFlagsInjectedMessageTemplates
	| undefined => useContext(InjectedMessageTemplatesContext);
